import { useToast } from '@repo/design-system/index'
import { ActivityComponentType } from '@stackflow/react'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import apis from '../../../modules/apis'
import { axiosPost } from '../../../modules/axiosHelper'
import { n_lesson, n_material_list, n_upcoming_lessons } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { BottomFixedSection, SelectMaterialProvider } from '../../../pages/[lang]/portal/lessons/materials/[lessonId]'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'
import { SearchResultListSection } from '../../new-portal/lessons/materials/SelectMaterialBody'
import SelectMaterialSearchSection from '../../new-portal/lessons/materials/SelectMaterialSearchSection'
import WebviewStackContainer from '../common/WebviewStackContainer'

interface IMaterialSearch {
  params: {
    lessonId: string
    materialId: string | null
  }
}

const LessonMaterialSearchActivity: ActivityComponentType = ({ params }: IMaterialSearch) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop, push } = useLessonsFlow()
  const { t } = useTranslation()
  const { toastError, toastSuccess } = useToast()
  const queryClient = useQueryClient()
  const [webviewKeyword, setWebviewKeyword] = useState('')

  // 교재 저장 버튼
  const handleClickSaveMaterial = async (lessonId, materialId) => {
    try {
      if (!materialId) {
        toastError(t(n_upcoming_lessons.edit_materials.tab_desc))

        return
      }

      const response = await axiosPost(apis.lessons.editCourse(), {
        lesson_id: lessonId,
        course_id: materialId,
      })

      if (response.success) {
        await queryClient.invalidateQueries([apis.lessons.upcomingsV5()])
        await queryClient.invalidateQueries([apis.lessons.upcomingsCount()])
        push('LessonHomeActivity', {})
        toastSuccess(t(n_upcoming_lessons.edit_materials.toast_select))
      } else {
        push('LessonHomeActivity', {})
        toastError(t(n_lesson.msg_material_auto3))
      }
    } catch (e) {
      alert(e.message)
    }
  }

  return (
    <SelectMaterialProvider>
      <WebviewStackContainer onBack={pop} title={t(n_material_list.all.title_search)}>
        <div className="relative mt-[16px] h-full">
          <SelectMaterialSearchSection setWebviewKeyword={setWebviewKeyword} lessonId={params.lessonId} />
          {webviewKeyword.length >= 1 ? (
            <div className="w-svw overflow-x-hidden py-20 px-16">
              <SearchResultListSection keywords={webviewKeyword} />
            </div>
          ) : (
            <div className="min-h-svh" />
          )}
          <BottomFixedSection lessonId={params.lessonId} handleClickSaveMaterialWebview={handleClickSaveMaterial} />
        </div>
      </WebviewStackContainer>
    </SelectMaterialProvider>
  )
}

export default LessonMaterialSearchActivity
